import { memo } from 'react'

interface CloseCircleIconProps {
  width?: number
  className?: string
}

const CloseCircleIcon: React.FC<CloseCircleIconProps> = memo(
  ({ width = 32, className = '' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 32 33"
      fill="none"
      className={className}
    >
      <path
        d="M16 18.8279L20.64 23.4679C20.9333 23.7612 21.3067 23.9079 21.76 23.9079C22.2133 23.9079 22.5867 23.7612 22.88 23.4679C23.1733 23.1746 23.32 22.8012 23.32 22.3479C23.32 21.8946 23.1733 21.5212 22.88 21.2279L18.24 16.5879L22.88 11.9479C23.1733 11.6546 23.32 11.2812 23.32 10.8279C23.32 10.3746 23.1733 10.0012 22.88 9.70789C22.5867 9.41456 22.2133 9.26789 21.76 9.26789C21.3067 9.26789 20.9333 9.41456 20.64 9.70789L16 14.3479L11.36 9.70789C11.0667 9.41456 10.6933 9.26789 10.24 9.26789C9.78667 9.26789 9.41333 9.41456 9.12 9.70789C8.82667 10.0012 8.68 10.3746 8.68 10.8279C8.68 11.2812 8.82667 11.6546 9.12 11.9479L13.76 16.5879L9.12 21.2279C8.82667 21.5212 8.68 21.8946 8.68 22.3479C8.68 22.8012 8.82667 23.1746 9.12 23.4679C9.41333 23.7612 9.78667 23.9079 10.24 23.9079C10.6933 23.9079 11.0667 23.7612 11.36 23.4679L16 18.8279ZM16 32.5879C13.7867 32.5879 11.7067 32.1679 9.76 31.3279C7.81333 30.4879 6.12 29.3479 4.68 27.9079C3.24 26.4679 2.1 24.7746 1.26 22.8279C0.42 20.8812 0 18.8012 0 16.5879C0 14.3746 0.42 12.2946 1.26 10.3479C2.1 8.40122 3.24 6.70789 4.68 5.26789C6.12 3.82789 7.81333 2.68789 9.76 1.84789C11.7067 1.00789 13.7867 0.587891 16 0.587891C18.2133 0.587891 20.2933 1.00789 22.24 1.84789C24.1867 2.68789 25.88 3.82789 27.32 5.26789C28.76 6.70789 29.9 8.40122 30.74 10.3479C31.58 12.2946 32 14.3746 32 16.5879C32 18.8012 31.58 20.8812 30.74 22.8279C29.9 24.7746 28.76 26.4679 27.32 27.9079C25.88 29.3479 24.1867 30.4879 22.24 31.3279C20.2933 32.1679 18.2133 32.5879 16 32.5879Z"
        fill="currentColor"
      />
    </svg>
  ),
)

export { CloseCircleIcon }
